var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.556,
    height: 20,
    viewBox: "0 0 15.556 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-delete-forever",
    "data-name": "Icon material-delete-forever",
    d: "M8.611,22.278A2.229,2.229,0,0,0,10.833,24.5h8.889a2.229,2.229,0,0,0,2.222-2.222V8.944H8.611Zm2.733-7.911L12.911,12.8l2.367,2.356L17.633,12.8,19.2,14.367l-2.356,2.356L19.2,19.078l-1.567,1.567-2.356-2.356-2.356,2.356-1.567-1.567,2.356-2.356Zm7.822-8.756L18.056,4.5H12.5L11.389,5.611H7.5V7.833H23.056V5.611Z",
    transform: "translate(-7.5 -4.5)",
    fill: "#4e4e4e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.4955069d2cbe51922ae5a20f6cb98075.svg";
export { ForwardRef as ReactComponent };